export enum NotaFiscalConsumidorFinal {
    Normal = 0,
    ConsumidorFinal = 1,
}

/** Campo que indica o CRT do cadastro quando for (CNPJ) */
export enum NotaFiscalCrt {
    SimplesNacional = 1,
    SimplesNacionalExcessoSublimite = 2,
    RegimeNormal = 3,
    MicroEmpreendedorIndividual = 4,
}

/** Quando tipo da nota fiscal for "Devolução" este campo indica se é uma devolução de uma compra do fornecedor ou devolução de uma venda para cliente */
export enum NotaFiscalDevolucaoOperacao {
    Compra = 1,
    Venda = 2,
}

export enum NotaFiscalIndicadorPresenca {
    NaoSeAplica = 0,
    Presencial = 1,
    NaoPresencialInternet = 2,
    NaoPresencialTeleatendimento = 3,
    NfceEntregaDomicilio = 4,
    PresencialForaEstabelecimento = 5,
    Outros = 9,
}

export enum NotaFiscalIndicadorIntermediador {
    OperacaoSemIntermediador = 0,
    OperacaoComIntermediador = 1,
}

export enum NotaFiscalMarketplaceIndicador {
    OperacaoSemIntermediador = 0,
    OperacaoComIntermediador = 1,
    SemOperador = 99,
}

export enum NotaFiscalModelo {
    NFe = 55,
    SAT = 59,
    NFCe = 65,
}

export enum NotaFiscalMotivoCompra {
    AtivoImobilizado = 1,
    Mercadorias = 2,
    ProdutorRural = 3,
    UsoOuConsumo = 4,
}

export enum NotaFiscalMotivoVenda {
    Venda = 1,
    Consignada = 2,
    EntregaFutura = 3,
    Suframa = 4,
    AOrdem = 5,
    Industrializacao = 6,
    AmbulanteProntaEntrega = 7,
    SomenteFiscal = 8,
    AtivoImobilizado = 9,
}

export enum NotaFiscalMovimento {
    Entrada = 1,
    Saida = 2,
}

export enum NotaFiscalRemessaRetornoMotivo {
    AmostraGratis = 1,
    AtivoImobilizado = 2,
    Bonificacao = 3,
    Comodato = 4,
    Conserto = 5,
    Consignacao = 6,
    ContaEOrdemDeTerceiros = 7,
    Demonstracao = 8,
    DepositoFechadoOuArmazemGeral = 9,
    EntregaFutura = 10,
    ExposicaoOuFeira = 11,
    Industrializacao = 12,
    IndustrializacaoPorContaDeOrdem = 13,
    OutrasSaidas = 14,
    Vasilhame = 15,
    VendaForaDoEstabelecimento = 16,
    Complemento = 17,
    Transferencia = 18,
    Garantia = 19,
}

export enum NotaFiscalRemessaRetornoOperacao {
    Entrada = 1,
    Saida = 2,
}

export enum NotaFiscalStatus {
    Nova = 0, // Somente no front
    Aguardando = 1,
    Incorreta = 2,
    Emitida = 3,
    Cancelada = 4,
    Rejeitada = 5,
    Estornada = 6,
}

export enum NotaFiscalTipo {
    Compra = 1,
    Venda = 2,
    Remessa = 3,
    Retorno = 4,
    Devolucao = 5,
    Ajuste = 6,
    Complementar = 7,
    Estorno = 8,
    Importada = 9,
    Credito = 10,
    Debito = 11,
}

export enum NotaFiscalTipoCredito {
    MultaJuros = 1,
    ApropriacaoCreditoPresumidoIBSZFM = 2,
    RetornoRecusaTotalEntregaOuNaoLocalizacaoDestinatario = 3,
    ReducaoValores = 4,
    TransferenciaCreditoSucessao = 5,
    RetornoRecusaParcialEntrega = 6,
}

export enum NotaFiscalTipoDebito {
    TransferenciaCreditosCooperativas = 1,
    AnulacaoCreditoSaidasImunesIsentas = 2,
    DebitosNotasFiscaisNaoProcessadasApuracao = 3,
    MultaJuros = 4,
    TransferenciaCreditoSucessao = 5,
    PagamentoAntecipado = 6,
    PerdaEstoque = 7,
    DesenquadramentoSimplesNacional = 8,
}

export enum NotaFiscalTransporteResponsavelFrete {
    ContratacaoFreteRemetente = 0,
    ContratacaoFreteDestinatario = 1,
    ContratacaoFreteTerceiros = 2,
    TransporteProprioRemetente = 3,
    TransporteProprioDestinatario = 4,
    SemOcorrenciaTransporte = 9,
}

export enum NotaFiscalTransporteSomarTotal {
    Nao = 1,
    Sim = 2,
}

export enum NotaFiscalTransporteUsaTransportadora {
    Sim = 1,
    Nao = 2,
}
